import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { template } from 'utils/TemplateReplacement';
import './style.css';

// eslint-disable-next-line react/prefer-stateless-function
class MemberLiveGroupNoticeMessageItem extends Component {
  render() {
    const { message } = this.props;
    return (
      <div style={{ textAlign: 'center' }}>
        <div className="message-notice">
          {template(message.messageMeta.noticeMessageTemplate, {
            memberUsername: (
              <Link
                key={`ownerLiveRoomNotice-${message.id}-${message.messageMeta.memberId}`}
                to={`/users/profile/${message.messageMeta.memberId}`}
              >
                {message.messageMeta.memberUsername}
              </Link>
            )
          })}
        </div>
      </div>
    );
  }
}

MemberLiveGroupNoticeMessageItem.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.number.isRequired,
    messageMeta: PropTypes.shape({
      noticeMessageTemplate: PropTypes.string.isRequired,
      memberUsername: PropTypes.string.isRequired,
      memberId: PropTypes.number.isRequired
    }).isRequired
  }).isRequired
};

export default MemberLiveGroupNoticeMessageItem;



// WEBPACK FOOTER //
// ./src/components/Messenger/content/RoomViewBlock/RoomMainBlock/_messages/MemberLiveGroupNoticeMessageItem.js